export default {
  downloadFile(data: string) {
    const fileLink = document.createElement('a')
    fileLink.href = data
    document.body.appendChild(fileLink)
    fileLink.click()
  },
  downloadFileFromUrl(url: string | null | undefined) {
    if (!url)
      return

    const fileLink = document.createElement('a')
    fileLink.href = url
    document.body.appendChild(fileLink)
    fileLink.click()
  },
}
